
export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    image() {
      let image = this.blok.background_image.filename
      if (this.blok.background_image_mobile.length) {
        if (this.$mq === 'sm') {
          image = this.blok.background_image_mobile.filename
        } else {
          image = this.blok.background_image.filename
        }
      }
      return image
    },
  },
}
